module.exports = __webpack_public_path__ + "static/media/unitedhealthcare.37dd83e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/images/partner/logos/unitedhealthcare.png
// module id = 40
// module chunks = 0